import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "invitationMessage",
    "communicableContactsSection",
    "communicableContactsHint",
    "contactBanner",
    "userBanner",
    "addPhoneDetailButton"
  ];

  connect() {
    if (this.hasAddPhoneDetailButtonTarget) {
      this.addPhoneDetailButtonTarget.addEventListener('click', (e) => this.addPhoneDetail(e));
    }
  }

  toggleInvitationMessage(event) {
    const invited = event.target.checked;

    this.invitationMessageTarget.classList.toggle("d-none", !invited);

    if (this.hasContactBannerTarget) {
      this.contactBannerTarget.classList.toggle("d-none", invited);
      this.userBannerTarget.classList.toggle("d-none", !invited);
    }
  }

  toggleCommunicableContacts(event) {
    const valid = this.isValidEmail(event.target.value);

    this.communicableContactsSectionTargets.forEach(el => el.classList.toggle("d-none", !valid));
    this.communicableContactsHintTargets.forEach(el => el.classList.toggle("d-none", valid));
  }

  toggleCommunicableContactRow(event) {
    const row = event.target.closest(".communicable-contact-row");

    row.querySelectorAll("[data-communicable-contact-field]").forEach(el => {
      el.disabled = !event.target.checked;
    });
  }

  addPhoneDetail(event) {
    event.preventDefault();

    const wrapper = this.element.querySelector('[data-phone-details-wrapper]');
    const template = this.element.querySelector('#phone-detail-template');
    if (!wrapper || !template) return;

    const rows = wrapper.querySelectorAll('.phone-detail-row');
    const newIndex = rows.length;

    const templateContent = template.content.cloneNode(true);
    this.incrementFieldIndices(templateContent, newIndex);
    wrapper.appendChild(templateContent);
  }

  incrementFieldIndices(element, index) {
    element.querySelectorAll('[name]').forEach(field => {
      const newName = field.name.replace(/phone_details_attributes\[\d+\]/, `phone_details_attributes[${index}]`);
      field.name = newName;
      field.id = newName.replace(/[[\]]/g, '_');
    });

    element.querySelectorAll('label[for]').forEach(label => {
      const newFor = label.getAttribute('for').replace(/phone_details_attributes\[\d+\]/, `phone_details_attributes[${index}]`);
      label.setAttribute('for', newFor);
    });
  }

  isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }
}
